const productionKey = 'd468b602-cb40-4be7-b15c-da65e70c7073';
const developmentKey = 'd468b602-cb40-4be7-b15c-da65e70c7073-test';
export const ONETRUST_KEY = process.env.NODE_ENV === 'production' ? productionKey : developmentKey;
